import { render, staticRenderFns } from "./TradingRank.vue?vue&type=template&id=448a74a7&scoped=true"
import script from "./TradingRank.vue?vue&type=script&lang=js"
export * from "./TradingRank.vue?vue&type=script&lang=js"
import style0 from "./TradingRank.vue?vue&type=style&index=0&id=448a74a7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a74a7",
  null
  
)

export default component.exports